import { styled } from "@mui/material/styles";
import { Box } from "@mui/system";

import { AnimationType } from "../../../../models/configuration/definitions/template";

const PREFIX = "KTemplatesWrapper";

export const classes = {
  fadeInBottom: `${PREFIX}-fadeInBottom`,
};

const StyledKTemplatesWrapper = styled(Box)<{ animationType: AnimationType | undefined }>(
  ({ animationType }) => ({
    ...(animationType &&
      animationType === AnimationType.FadeInBottom && {
        animationName: "fadeInBottom",
        animationDuration: "1s",
        animationFillMode: "both",

        "@keyframes fadeInBottom": {
          from: {
            opacity: 0,
            transform: "translateY(100%)",
          },
          to: { opacity: 1 },
        },
      }),
  }),
);

export default StyledKTemplatesWrapper;
